<div class="m-messages-wrapper">
  <m-messages
    *ngIf="showBanner"
    [messages]="messages"
    [closable]="true"
    (closeMessage)="handleClose()">
  </m-messages>
</div>
